import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  register: (username, email, password) =>
    api.post('/auth/register', { username, email, password }),

  login: (username, password) =>
    api.post('/auth/login', { username, password }),

  me: () => api.get('/auth/me'),

  forgotPassword: (email) =>
    api.post('/auth/forgot-password', { email }),

  resetPassword: (token, newPassword) =>
    api.post('/auth/reset-password', { token, newPassword }),
};

// Payment API
export const paymentAPI = {
  getConfig: () => api.get('/payment/config'),

  createPaymentIntent: () => api.post('/payment/create-payment-intent'),

  confirmPayment: (paymentIntentId) => api.post('/payment/confirm', { paymentIntentId }),

  getStatus: () => api.get('/payment/status'),
};

// Progress API
export const progressAPI = {
  getProgress: () => api.get('/progress'),

  updateProgress: (data) => api.post('/progress', data),

  getTopicProgress: () => api.get('/progress/topics'),

  updateTopicProgress: (topicId, data) =>
    api.post(`/progress/topics/${topicId}`, data),
};

// History API
export const historyAPI = {
  recordQuestion: (data) => api.post('/history/question', data),

  recordAnswer: (data) => api.post('/history/question', data),

  getHistory: () => api.get('/history'),

  getStats: () => api.get('/history/stats'),

  getWeakQuestions: (limit = 5) => api.get(`/history/stats/weak?limit=${limit}`),

  getStrongQuestions: () => api.get('/history/stats/strong'),
};

// Achievements API
export const achievementsAPI = {
  getAchievements: () => api.get('/achievements'),

  addAchievement: (data) => api.post('/achievements', data),
};

// Wrong Answers API
export const wrongAnswersAPI = {
  getWrongAnswers: () => api.get('/wrong-answers'),

  addWrongAnswer: (data) => api.post('/wrong-answers', data),

  markAsMastered: (id) => api.put(`/wrong-answers/${id}/master`),
};

// Stats API
export const statsAPI = {
  getUserStats: () => api.get('/stats'),
};

// Questions API
export const questionsAPI = {
  getCategories: () => api.get('/questions/categories'),

  getQuestions: (category, difficulty, count = 10) =>
    api.get('/questions', { params: { category, difficulty, count } }),

  getExamQuestions: (count = 20) =>
    api.get('/questions/exam', { params: { count } }),

  getRandomQuestions: (count = 10) =>
    api.get('/questions/random', { params: { count } }),
};

// Sessions API
export const sessionsAPI = {
  canAccessQuiz: () => api.get('/sessions/can-access-quiz'),

  startSession: (gameMode) => api.post('/sessions/start', { gameMode }),

  endSession: (sessionId, data) =>
    api.post(`/sessions/${sessionId}/end`, data),
};

export default api;
